import styled from '@emotion/styled';

export const FormSection = styled.div<{ noMargin?: boolean }>`
    background-color: ${({ theme }) => theme.colors.light};
    border-radius: ${({ theme }) => theme.borderRadius.small}px;
    margin-bottom: ${({ noMargin }) => (noMargin ? 0 : '1rem')};
    padding: 24px;
`;
